// i18n area 'vms' — locale nl-NL (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/vms.nl-NL.meta.json.
import type { enUS } from './vms'

export const nlNL: typeof enUS = {
  vms: {
    spof: {
      title: 'Onafhankelijkheid van de node',
      single: 'Enkelvoudig faalpunt',
      alternativesNow: 'Alternatieven nu',
      structural: 'Door constructie',
      binding: 'Bindende beperking',
      movableNow: 'Nu migreerbaar',
    },
    title: 'Virtuele machines',
    migratingChip: 'Migratie bezig',
    templateChip: 'Template',
    expendableTooltip: 'In een gedegradeerd cluster is hij een van de eersten die wordt gestopt en start mogelijk niet opnieuw na het verlies van een node.',
    expendableHaTooltip: 'Wordt altijd herstart zolang het cluster gezond is; in een gedegradeerd cluster gaan beschermde VM\'s voor — hij kan worden gestopt of uit blijven totdat het cluster weer compleet is, daarna keert hij vanzelf terug.',
    viewDetails: 'Details bekijken',
    profileLegacy: 'Ander OS',
    hugePagesNone: 'Geen — gewoon geheugen',
    hugePages2M: "Pagina's van 2 MiB",
    hugePages1G: "Pagina's van 1 GiB",
    searchPlaceholder: 'Zoeken op naam',
    name: 'Naam',

    // Terminologie UNA (#94a): de phase heet overal 'Fase' — de oude sleutel
    // 'state' is gestorven met de polish van de lijst.
    vcpus: 'vCPU',
    memory: 'Geheugen',
    ipAddresses: 'IP-adressen',
    noIp: 'Geen IP',
    authorityNode: 'Authority',
    authorityNextStart: 'toegewezen bij de volgende start',
    scope: 'Scope',
    empty: 'Geen virtuele machine',
    loadError: 'De virtuele machines konden niet worden geladen — is de TVirt-backend bereikbaar?',
    filterOverlay: 'overlaynetwerk',
    filterDisk: 'schijf',
    filterImage: 'image',
    filteredBy: 'Gefilterd op {kind}',
    filterPhase: 'Fase',
    filterProtection: 'Bescherming',
    filterAll: 'Alle',
    filterScopePlaceholder: 'Filteren op scope',
    filtersToggle: 'Filters',
    scopeTree: {
      title: 'Scope',
      all: 'Het hele cluster',
      noChildren: 'Hier zijn geen sub-scopes',
      recursive: 'Onderliggende meenemen',
      collapse: 'Scope-paneel inklappen',
      up: 'Eén niveau omhoog',
      countTooltip: "{direct} VM's in deze scope · {total} inclusief onderliggende"
    },

    // De ISO-picker in twee stappen (#85): eerst de catalogus, dan zijn ISO's.
    isoPicker: {
      catalog: 'Catalogus',
      unknownCatalog: 'Buiten de zichtbare catalogi',
      noIsos: 'Geen enkele ISO-image gereed in deze catalogus'
    },
    actionsHeader: 'Acties',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Hardware',
      tags: 'Tags',
      age: 'Leeftijd',
      disk: 'schijf',
      disks: 'schijven',
      empty: 'Geen enkel template — markeer een uitgeschakelde VM als template, of kloon een VM als template.',
      clone: 'Klonen / deploy',
      editTags: 'Tags bewerken',

      // Ronde K3 (#64): exporteert het template als .tvtpl-bestand van de catalogus.
      exportAction: 'Exporteren naar de catalogus (.tvtpl)',
      exportTitle: 'Exporteren naar de catalogus',
      exportSubmit: 'Exporteren',
      exportError: 'Export mislukt',
      exportHint: "Het template wordt ingepakt in een .tvtpl-archief (hardwaremanifest + elke schijf platgeslagen naar qcow2) als nieuw bestand VM Template in de gekozen catalogus. NIC's, cd-/dvd-media en cloud-init reizen niet mee — de spec van het formaat somt elke bewuste weglating op.",
      exportName: 'Naam van het bestand',
      exportNameHint: 'Leeg = <template>-export-<n>',
      exportStorageDefault: 'De metadatastorage van het template',

      // Importeren uit catalogus (Luca 2026-08-03): de toolbar-ingang van het
      // tabblad Templates — de backend K3/K4 dekt alle vm-template-formaten,
      // de keuze is het BESTAND (het formaat reist alleen-lezen mee).
      importAction: 'Importeren uit catalogus',
      importTitle: 'Importeren uit catalogus',
      importHint: 'Een bestand VM Template met status ready uit de gekozen catalogus wordt een template van de inventaris: het formaat van het bestand (tvtpl, ova, ovf of kale qcow2) bepaalt zelf hoe het wordt geïmporteerd — jij kiest alleen het bestand.',
      importFile: 'Catalogusbestand',
      importFileHint: 'Alleen bestanden met status ready zijn te importeren — een bestand halverwege de upload niet',
      importNoFiles: 'Geen enkel bestand VM Template met status ready in deze catalogus — upload of exporteer er eerst een'
    },
    templateDetail: {
      quickDeploy: 'QuickDeploy-compatibiliteit',
      quickDeployNone: 'Niet verklaard',
      quickDeployHint: 'Verklaar die alleen als de golden image cloud-init (Linux) of cloudbase-init na sysprep /generalize (Windows) bevat: het platform vertrouwt de verklaring en kijkt nooit in de guest.',
      notFound: 'Template niet gevonden',
      frozen: 'De hardwareconfiguratie is bevroren: zet het template terug naar VM om haar te wijzigen. Naam, notities en tags blijven bewerkbaar.',
      storage: 'Storage',
      size: 'Grootte',
      configTitle: 'Configuratie (bevroren)',
      usbClasses: 'Vereiste USB-klassen',
      gpuClasses: 'Vereiste GPU-klassen'
    },
    sharedDisksTab: {
      title: 'Gedeelde schijven',
      sharing: 'Delen',
      sharingNone: 'Één koppeling',
      sharingMultiwriter: 'Gedeeld schrijven (multiwriter)',
      sharingReadonly: 'Gedeeld alleen-lezen',
      usedBy: 'In gebruik door',
      attachedTo: 'Gekoppeld aan',
      notAttached: 'Aan geen VM gekoppeld',
      changeSharing: 'Deelmodus wijzigen',
      changeSharingTitle: 'Deelmodus',
      changeSharingLocked: 'De modus verandert alleen zolang geen VM de schijf gebruikt',
      sharingChanged: 'Deelmodus bijgewerkt.',
      lun: 'Hele LUN',
      lunNumber: 'LUN / namespace',
      lunWwn: 'WWN',
      lunSerial: 'Serienummer',
      antiAffinityWarning: 'Twee of meer leden draaien op dezelfde node zonder anti-affiniteitsregel: één node-uitval haalt ze allemaal neer',
      antiAffinityCreate: 'Regel aanmaken',
      createSourceLun: 'Een hele LUN van het target overnemen',
      createLunNumber: 'LUN-nummer (namespace-id bij NVMe)',
      createLunHint: 'Er wordt niets toegewezen: de grootte wordt bij het overnemen van het apparaat gelezen',
      noPr: 'Geen SCSI-3 persistent reservations in deze release: een Windows Failover Cluster met klassieke gedeelde schijf is niet gevalideerd; clusters die via het netwerk coördineren (GFS2/OCFS2, RHEL HA, shared-disk-databases) wel'
    },
    unusedDisksTab: {
      title: 'Ongebruikte schijven',
      attach: 'Aan een VM koppelen',
      attachTitle: 'Aan een VM koppelen',
      vm: 'Virtuele machine',
      noVms: 'Geen VM beschikbaar',
      noSlots: 'Geen vrij slot op deze VM',

      // Standalone schijf aanmaken (#87): terug uit de gepensioneerde
      // Inventaris, nu met EXPLICIET scope-veld (er is geen VM om van te erven).
      create: 'Schijf aanmaken',
      createTitle: 'Schijf aanmaken',
      createSourceBlank: 'Lege schijf',
      createSourceImage: 'Vanaf een catalogus-image',
      createImage: 'Image',
      createImageEmpty: 'Geen gereed VM-sjabloon-image in de zichtbare catalogi',
      createSizeFromImageHint: 'Vooraf ingevuld met de virtuele grootte van het image — kan alleen groeien',

      // #107 (DESTRUCTIEF, geratificeerd): qcow2 → catalogusbestand vm-template
      // op dezelfde storage, geen byte gekopieerd — de schijf houdt op te bestaan.
      convert: 'Omzetten naar VM-template…',
      convertOnlyQcow2: 'Alleen qcow2-schijven zijn om te zetten — raw is geen registreerbaar templateformaat',
      convertTitle: 'Omzetten naar VM-template',
      convertSubmit: 'Omzetten (vernietigt de schijf)',
      convertError: 'De omzetting kon niet worden gestart',
      convertWarning: 'DESTRUCTIEF: de schijf wordt een bestand VM-template in de gekozen catalogus — dezelfde storage, geen enkele byte gekopieerd — en HOUDT OP TE BESTAAN als schijf. Terug kan alleen door een nieuwe schijf uit het template te maken.',
      convertNameHint: 'De naam van het catalogusbestand — standaard die van de schijf',
      convertConfirm: 'Ik heb het begrepen: de schijf wordt vernietigd',
      convertStarted: 'Omzetting gestart — het template verschijnt in de catalogus zodra de task sluit.',
      storageLockHint: 'De storage verandert alleen met de actie Verplaatsen',
      source: 'Herkomst',
      sourceClone: 'Kloon van een andere schijf',
      sourceCloneLinked: 'Linked clone van een andere schijf',
      sourceImage: 'Aangemaakt vanaf een image',
      sourceBlank: 'Leeg aangemaakt',
      allocated: 'Toegewezen / virtuele grootte',
      observedAt: 'Waargenomen op',
      snapshots: 'Snapshots',
      snapshotsEmpty: 'Geen snapshot'
    },
    phase: {
      defined: 'Nooit aan geweest',
      starting: 'Wordt gestart',
      running: 'Draait',
      stopping: 'Wordt gestopt',
      stopped: 'Gestopt',
      paused: 'Gepauzeerd',
      failed: 'In fout',
      deleting: 'Wordt verwijderd'
    },
    stopCause: {
      'api': 'Gestopt door TVirt (actie of API)',
      'guest-shutdown': 'Shutdown gestart door het besturingssysteem van de guest',
      'crash': 'Crash van de guest',
      'qemu-exit': 'Het QEMU-proces is onverwacht geëindigd',
      'host-reboot': 'De node is herstart',
      'migrated': 'Gemigreerd naar een andere node',
      'fenced': 'Beëindigd door de HA-fencing (node teruggekeerd)'
    },
    detail: {
      notFound: 'Virtuele machine niet gevonden',
      details: 'Details',
      id: 'ID',
      scope: 'Scope',
      profile: 'Hardwareprofiel',
      firmware: 'Firmware',
      firmwareFile: 'UEFI-firmwareversie',
      firmwareUpdate: 'Update beschikbaar',
      firmwareUpdateHint: 'Het platform levert een nieuwere UEFI-firmware. De update gebeurt nooit automatisch: hij wordt toegepast als de VM uit staat, wanneer jij dat beslist.',
      arch: 'Architectuur',
      node: 'Node',
      bootOrder: 'Opstartvolgorde',
      agent: 'Status van de agent',
      agentConnected: 'Verbonden',
      agentNotConnected: 'Niet verbonden',
      protected: 'Beschermd',
      linkedClones: 'Gekoppelde klonen',
      restartPolicy: 'Herstartbeleid',
      preferredNode: 'Voorkeursnode',
      noPreference: 'Geen voorkeur (automatische placement)',
      preferNodes: 'Voorkeurstags voor nodes',
      requireNodes: 'Verplichte tags voor nodes',
      noPlacementTags: 'Geen',
      placementTag: 'Tag',
      placementValue: 'Waarde',
      placementAddTag: 'Tag toevoegen',
      proximityHa: 'HA van TVirt Proximity',
      proximityHaRestarts: 'HA-herstarts',
      proximityHaGaveUp: 'crash loop — HA geeft het op',
      failoverProtection: 'Bescherming in gedegradeerd cluster',
      protectionProtected: 'Beschermd',
      protectionExpendable: 'Opofferbaar bij degradatie',
      protectionInherit: 'Overerven',
      lastStop: 'Laatste stop',
      yes: 'Ja',
      no: 'Nee',
      tabOverview: 'Overzicht',
      tabSnapshots: 'Snapshots',
      tabBackups: 'Back-ups',
      hardware: 'Hardware',
      name: 'Naam',
      hwSystem: 'Systeem',
      hwCpu: 'CPU',
      hwMemory: 'Geheugen',
      hwBoot: 'Opstarten',
      hwIdentity: 'Identiteit',
      hwCluster: 'Cluster en agent',
      cpuTopology: 'CPU-topologie',
      cpuModel: 'CPU-model',
      cpuLimit: 'CPU-limiet',
      cpuWeight: 'CPU-gewicht',
      cpuNested: "Geneste virtualisatie",
      cpuNestedHint: "Stelt vmx/svm beschikbaar aan de gast (alleen met CPU-model host). Op een draaiende VM geldt de wijziging vanaf de volgende power cycle (PendingRestart); plaatsing laat alleen nodes toe met nested ingeschakeld.",
      unlimited: 'Onbeperkt',
      memory: 'Geheugen',
      balloon: 'Balloon',
      hugePages: "Enorme pagina's",
      hugePagesTradeoff: "Minder adresvertaalwerk en geheugen dat nooit op schijf belandt; in ruil blijft de reservering op de node vastgezet zolang de VM draait, wordt het geheugen niet meer gededupliceerd en mislukt de start als de node te weinig vrije pagina's heeft.",
      disks: 'Schijven',
      cdroms: 'Cd-/dvd-stations',
      nics: 'Netwerkinterfaces',
      slot: 'Slot',
      disk: 'Schijf',
      encrypted: 'Versleuteld',
      image: 'Image',
      emptyDrive: 'Leeg station',
      emptyOption: '(leeg)',
      network: 'Netwerk',
      mac: 'MAC',
      connected: 'Aangesloten',
      unplugged: 'Losgekoppeld',
      noDevices: 'Geen',
      screenshot: 'Schermafbeelding',
      capturedAt: 'Vastgelegd om',
      noCapture: 'Geen opname',
      snapshotName: 'Naam',
      snapshotCreated: 'Aangemaakt',
      snapshotMemory: 'Geheugen inbegrepen',
      noSnapshots: 'Geen snapshot',
      pendingRestart: 'Wijzigingen in afwachting: ze worden toegepast bij de volgende power cycle.',
      applied: 'toegepast',
      appliedHint: 'De VM draait met deze waarde — de geconfigureerde waarde geldt bij de volgende power cycle.',
      actionError: 'Actie mislukt',
      actionStillRunning: 'De actie loopt nog — de uitkomst is nog niet bekend',
      tabConsole: 'Console',
      consoleConnect: 'Verbinden',
      consoleDisconnect: 'Verbinding verbreken',
      consoleConnecting: 'Verbinden…',
      consoleReconnecting: 'Verbinden…',
      consoleUnavailable: 'De console is beschikbaar terwijl de VM draait of gepauzeerd is.',
      consoleError: 'Verbinden met de console is mislukt',
      consoleTaken: 'Consolesessie overgenomen door {user}',
      consoleReconnect: 'Opnieuw verbinden',
      consoleCtrlAltDel: 'Ctrl+Alt+Del',
      consoleHold: '{key} ingedrukt houden',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Volledig scherm openen in een nieuw tabblad',
      consoleLoadFailed: 'VM niet gevonden of onvoldoende rechten',
      consoleClose: 'Sluiten',
      tabStats: 'Statistieken',
      tabTasks: 'Tasks',
      tabLogs: 'Logs',
      statsCpu: 'CPU',
      statsMemory: 'Geheugen',
      statsDisk: 'Schijf-I/O',
      statsRange: 'Interval',
      statsNoData: 'Geen gegevens in het interval — de statistieken worden bemonsterd terwijl de VM draait.',
      statsError: 'De statistieken konden niet worden geladen',
      cpuUsage: 'Gebruik',
      cpuReady: 'Ready (%RDY)',
      memUsed: 'Gebruikt',
      memGuestAvailable: 'Beschikbaar (guest)',
      schema: 'Schema',
      consoleProtocol: 'Console',
      agentEnabled: 'Guest agent',
      metadataStorage: 'Metadatastorage',
      startupOnBoot: 'Starten bij het opstarten',
      startupOrder: 'Startvolgorde',
      startupDelay: 'Startvertraging',
      seconds: 's',
      enabled: 'Ingeschakeld',
      disabled: 'Uitgeschakeld'
    },
    actionsAvailable: 'Beschikbare acties',
    actions: {
      start: 'Starten',
      stop: 'Stoppen',
      pause: 'Pauzeren',
      resume: 'Hervatten',
      reset: 'Reset',
      migrate: 'Migreren',
      clone: 'Klonen',
      moveStorage: 'Verplaatsen naar storage…',
      moveScope: 'Verplaatsen naar scope…',
      openConsole: 'Console openen',
      forceStop: 'Uitschakelen forceren',
      markTemplate: 'Als template markeren',
      unmarkTemplate: 'Terugzetten naar VM',
      error: 'De actie kon niet worden uitgevoerd'
    },
    cordon: {
      confirmTitle: 'De node is in onderhoud',
      confirmHint:
        'Het kordon kan niet omlaag zolang de cluster-store onbereikbaar is. Met bevestigen verklaar je dat je dat weet: de VM start daar toch, en de toestemming blijft vastgelegd op de taak.',
      confirm: 'Toch starten'
    },
    markTemplate: {
      confirmTitle: '{name} als template markeren?',
      confirmBody: 'De configuratie bevriest en de VM kan niet meer aangaan — hij kan alleen nog worden gekloond, of weer VM worden. Naam, notities en tags blijven bewerkbaar.',
      confirm: 'Als template markeren',
      moved: '{name} is nu een template — hij is verhuisd naar het tabblad Templates.'
    },
    unmarkTemplate: {
      confirmTitle: '{name} terugzetten naar VM?',
      confirmBody: 'Het template wordt weer een gewone VM: bewerkbaar en startbaar (de volgende start plaatst hem op een node).',
      confirm: 'Terugzetten naar VM',
      moved: '{name} is weer een virtuele machine — hij is verhuisd naar het tabblad Virtuele machines.'
    },

    // Ronde #123: verwijzing naar een node per TAG (selector #106) in de
    // dialogen van start en migratie — inclusief voorbeeld van de opgeloste set.
    nodeByTag: {
      label: 'Op nodetag',
      hint: "tag=waarde, gescheiden door komma's (in AND): de decider kiest uit de overeenkomende nodes",
      invalid: "Ongeldig formaat — gebruik tag=waarde, gescheiden door komma's",
      resolved: 'Overeenkomende leden: {nodes}'
    },
    migrate: {
      title: 'Live migration',
      submit: 'Migreren',
      target: 'Doelnode',
      auto: 'Automatisch (Proximity)',
      hint: 'De VM verhuist zonder power cycle. Elke storage die hij raakt moet gedeeld zijn; een gepauzeerde VM migreert gepauzeerd.',
      error: 'De migratie is geweigerd'
    },
    moveStorage: {
      title: 'Verplaatsen naar storage',
      submit: 'Verplaatsen',
      target: 'Doelstorage',
      noTargets: 'Geen enkele storage accepteert schijven',
      hint: 'Alle schijven van de uitgeschakelde VM reizen naar de gekozen storage, één voor één, met behoud van hun id — de schijven die er al staan worden overgeslagen. De voortgang woont op de pagina Tasks.',
      error: 'De verplaatsing is geweigerd'
    },
    moveScope: {
      title: 'Verplaatsen naar scope',
      submit: 'Verplaatsen',
      target: 'Doelscope',
      hint: 'De VM wisselt onmiddellijk van scope — id en schijven blijven, de schijven die hij bezit volgen hem, en hij mag aan blijven staan. Vandaag woont hij in {scope}. Wie hem ziet verandert mee met de scope.',
      error: 'De scopeverplaatsing is geweigerd'
    },
    start: {
      title: 'VM starten',
      submit: 'Starten',
      target: 'Doelnode',
      auto: 'Automatisch (aanbevolen)',
      recommended: 'aanbevolen',
      hint: 'Kies een doelnode of laat Proximity beslissen tussen de geldige kandidaten. De nodes die hem niet kunnen herbergen staan uitgeschakeld, met de reden erbij.',
      error: 'De VM kon niet worden gestart'
    },
    console: {
      media: 'Cd-/dvd-stations',
      mediaGuestToolsHint: 'Bevat de TVirt Guest Tools — hiervandaan kun je ze uitwerpen of het station weghalen',
      slotOpsDeferred: 'Op dit profiel gelden het toevoegen en weghalen van stations pas bij de volgende power cycle (mediawissels zijn onmiddellijk).',
      mountGuestTools: 'TVirt Guest Tools plaatsen',
      ejectGuestTools: 'TVirt Guest Tools uitwerpen',
      bootOrder: 'Opstartvolgorde',
      bootOrderHint: 'De nieuwe volgorde wordt meteen opgeslagen en geldt bij de volgende power cycle — de consolesessie blijft verbonden.'
    },
    snapshots: {
      create: 'Snapshot aanmaken',
      createTitle: 'Een snapshot aanmaken',
      createSubmit: 'Aanmaken',
      name: 'Naam',
      nameHint: 'Letters, cijfers, punt, koppelteken, underscore.',
      consistencyHint: 'De consistentie gaat vanzelf: de guest agent bevriest de bestandssystemen wanneer hij antwoordt; anders gaat de VM even in pauze rond de snapshot.',
      memory: 'Het geheugen meenemen',
      memoryHint: 'Legt het levende RAM vast: het herstel hervat de VM in bedrijf. Vereist dat alle schijven qcow2 zijn.',
      currentChip: 'Je bent hier',
      revert: 'Herstellen',
      revertTitle: '{name} herstellen?',
      revertBody: 'De schijven keren terug naar de staat van de snapshot; alles wat daarna is gebeurd gaat verloren. Een snapshot met alleen schijven vereist een gestopte VM.',
      delete: 'Verwijderen',
      deleteTitle: 'Snapshot {name} verwijderen?',
      deleteBody: 'Het herstelpunt verdwijnt; de inhoud van de schijven blijft intact.',
      deleteMergeHint: 'Zijn delta wordt samengevoegd in {children}: elk later herstelpunt blijft geldig.',
      deleteDuplication: 'Ik accepteer de duplicatie',
      deleteDuplicationHint: 'De delta wordt gekopieerd naar elk van de {count} lezers (de kind-snapshots en, als dit de huidige is, de actieve kop): de gebruikte ruimte kan groeien in plaats van krimpen.',
      error: 'De bewerking op de snapshot is geweigerd'
    },
    clone: {
      title: 'VM klonen',
      submit: 'Klonen',
      name: 'Naam van de kopie',
      storage: 'Doelstorage voor de schijven',
      sameStorage: 'Dezelfde als de bron',
      full: 'Volledige kopie',
      fullHint: 'Kopieert elke byte en snijdt de band met de bronschijven door. De standaard is een linked clone: onmiddellijk, maar geketend aan de bron (alleen qcow2).',
      hint: 'De kloon behoudt de configuratie en de firmware van de bron; de MAC-adressen en de TPM-identiteit zijn nieuw.',
      markAs: 'Type van de kloon',
      markAsInheritVm: 'Zoals de bron (VM)',
      markAsInheritTemplate: 'Zoals de bron (template)',
      markAsVm: 'Virtuele machine',
      markAsTemplate: 'Template',
      markAsHintVm: 'Kies Template om de kopie in één stap te promoveren.',
      markAsHintTemplate: 'Kies Virtuele machine om dit template in één stap uit te rollen.',
      error: 'Het klonen is geweigerd'
    },
    bulk: {
      selected: 'geselecteerd',
      deleteTitle: {
        one: '{count} geselecteerde VM verwijderen?',
        other: "{count} geselecteerde VM's verwijderen?"
      },
      deleteBody: 'Elke VM passeert dezelfde controles als bij een enkele verwijdering; de weigeringen worden per element gemeld.',
      done: 'geaccepteerd',
      refused: 'geweigerd'
    },
    delete: {
      button: 'Verwijderen',
      confirmTitle: '{name} verwijderen?',
      confirmBody: 'De virtuele machine en de schijven die hij bezit worden verwijderd. De bewerking is niet omkeerbaar.',
      keepDisks: 'De schijven behouden',
      keepDisksHint: 'De schijven die met de VM zijn aangemaakt blijven in hun storage staan als zelfstandige schijven.',
      confirm: 'Verwijderen',
      cancel: 'Annuleren',
      error: 'Verwijderen mislukt',
      blockedPhase: 'Stop eerst de VM',
      blockedProtected: 'De VM is beschermd — haal eerst de bescherming weg',
      blockedDeleting: 'Er loopt al een verwijdering'
    },
    logs: {
      title: 'Logs',
      subtitle: 'Gestructureerde logframes van de tasks die deze VM raken',
      when: 'Wanneer',
      task: 'Task',
      level: 'Niveau',
      message: 'Bericht',
      empty: 'Nog geen log',
      loadError: 'De logs konden niet worden geladen — is de TVirt-backend bereikbaar?'
    },
    stop: {
      title: 'Virtuele machine stoppen',
      modeGraceful: 'Nette afsluiting',
      modeGracefulHint: 'Het besturingssysteem van de guest wordt gevraagd zichzelf op natuurlijke wijze af te sluiten (ACPI); negeert het het verzoek, dan volgt na de timeout de geforceerde uitschakeling.',
      modeForced: 'Geforceerde uitschakeling',
      modeForcedHint: 'Haalt de stroom er onmiddellijk af, alsof je de stekker eruit trekt.',
      timeout: 'Fallback-timeout (seconden)',
      timeoutHint: 'Wachttijd die de guest krijgt voordat de uitschakeling wordt geforceerd'
    },

    // Het menu van de splitknop voor aanmaken (Luca 2026-07-23): "Vanaf nul"
    // opent de wizard, de andere twee items zijn roadmap-stubs.
    createFromScratch: 'Vanaf nul',
    createFromTemplate: 'Vanaf een template',
    createQuickDeploy: 'TVirt QuickDeploy',

    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Deploy uitvoeren',
      error: 'Deploy mislukt',
      compatNote: 'QuickDeploy vereist een QuickDeploy-compatibel template: het platform past de guest (netwerk, domein, activering) aan bij de eerste start.',
      template: 'Template',
      noTemplates: 'Nog geen template verklaart QuickDeploy-compatibiliteit — verklaar die vanaf het tabblad Templates (Linux met cloud-init, Windows met cloudbase-init na sysprep)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Hostnaam',
      hostnameHint: 'Hostnaam of FQDN; leeg = de naam van de VM (Windows: hoogstens 15 tekens)',
      ip: 'IP-adres',
      ipHint: 'Host en prefix, bijv. 192.168.122.101/24; leeg = DHCP',
      gateway: 'Gateway',
      dns: 'DNS-servers',
      dnsHint: 'Maximaal drie, gescheiden door komma\'s',
      count: 'Instanties',
      countHint: 'Meer dan één: genoemd <naam>-1…-N, alleen DHCP',
      user: 'Gebruiker',
      userHint: 'Leeg = de standaardgebruiker van de image (Linux) of Administrator (Windows)',
      password: 'Wachtwoord',
      passwordHint: 'Wordt in de gegenereerde user-data geschreven, die het platform daarna geheim verklaart: niemand leest die terug',
      sshKeys: 'Publieke SSH-sleutels',
      sshKeysHint: 'Eén per regel (ssh-ed25519 AAAA… commentaar)',
      productKey: 'Windows-productsleutel',
      kmsServer: 'KMS-server',
      kmsHint: 'Host of host:poort — vereist een productsleutel (een KMS-clientsleutel)',
      adDomain: 'Active Directory-domein joinen',
      adDomainHint: 'Leeg = geen domein-join',
      adUser: 'Join-account',
      adPassword: 'Wachtwoord van het join-account',
      adOu: 'Doel-OU (optioneel)',
      advanced: 'Geavanceerd: ruwe documenten',
      userData: 'user-data (ruw)',
      userDataHint: 'Vervangt de gegenereerde user-data: gebruiker, wachtwoord, sleutels en de Windows-velden hierboven moeten leeg blijven',
      networkConfig: 'network-config (ruw)',
      networkConfigHint: 'Vervangt het gegenereerde netwerk: IP, gateway en DNS hierboven moeten leeg blijven',
      secret: 'De ruwe user-data als geheim behandelen',
      secretHint: 'Als geheim gemarkeerd geeft de API die aan niemand meer terug en reist die in de Checkpoint verzegeld met de masterpass',
      startNow: 'Meteen starten',
      startNowHint: 'Elke instantie start zodra die gedefinieerd is; de seed ontstaat bij die start'
    },

    create: {
      nicAttachmentNetwork: 'Logisch netwerk (fabric)',
      nicNetwork: 'Logisch netwerk',
      nicNetworkHint: 'De AANBEVOLEN weg (F3): de vNIC realiseert zich op de AFGELEIDE bridge van de dienende node — de bridge ontstaat bij de expliciete fabric-apply, en een start op een node die hem nog niet draagt weigert sprekend. Als de laatste referentie van de vloot vertrekt, valt de bridge er bij de volgende apply uit.',
      button: 'VM aanmaken',
      title: 'Virtuele machine aanmaken',
      dialogTitle: 'Virtuele machine aanmaken',
      stepGeneral: 'Algemeen',
      stepGeneralHint: 'Naam en profiel',
      stepCompute: 'CPU en RAM',
      stepComputeHint: 'Topologie en afmetingen',
      stepDisks: 'Schijven',
      stepDisksHint: 'Aanmaken of koppelen',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Stations en media',
      stepNetwork: 'Netwerk',
      stepNetworkHint: 'NIC: trunk of bridge',
      stepSummary: 'Samenvatting',
      stepSummaryHint: 'Controleren en aanmaken',
      name: 'Naam',
      nameHint: 'Kleine letters, cijfers en koppeltekens (DNS-1123)',
      nextButton: 'Volgende',
      prevButton: 'Vorige',
      submitButton: 'Aanmaken',
      creating: 'Aanmaken…',
      sockets: 'Sockets',
      cores: 'Cores per socket',
      threads: 'Threads per core',
      totalVcpus: 'vCPU totaal',
      memoryGib: 'Geheugen (GiB)',
      cpuModelHint: "'host' toont de CPU van de host",
      cpuLimitHint: 'Plafond in hostcores — leeg = onbeperkt',
      cpuNestedHint: "Stelt vmx/svm beschikbaar aan de gast zodat die een eigen hypervisor kan draaien — vereist het CPU-model host en een node met nested ingeschakeld",
      newDisk: 'Nieuwe schijf',
      attachDisk: 'Bestaande schijf koppelen',
      diskStorage: 'Storage',
      diskSize: 'Grootte (GiB)',
      diskSelect: 'Schijf',
      addDisk: 'Schijf toevoegen',
      addCdrom: 'Cd-/dvd-station toevoegen',
      addNic: 'Netwerkinterface toevoegen',
      remove: 'Weghalen',
      slotLimit: 'Slotlimiet bereikt',
      cdromImage: 'Image (leeg station als er geen is)',
      nicAttachment: 'Koppeling',
      nicAttachmentTrunk: 'Overlay-trunk',
      nicAttachmentBridge: 'Host-bridge',
      nicUntagged: 'Untagged overlay',
      nicUntaggedNone: 'Geen (alleen tagged)',
      nicTrunkHint: 'Minstens één kant: een untagged overlay en/of tagged VLAN-mappings — de VM kan alleen draaien op de hosts die elke gerefereerde overlay declareert',
      nicTaggedVlan: 'VLAN-ID',
      nicTaggedOverlay: 'Overlaynetwerk',
      addTagged: 'Tagged VLAN toevoegen',
      nicBridge: 'Naam van de host-bridge',
      nicBridgeHint: 'NM-bridge op naam — de VM kan alleen draaien op de servers waarvan het host network deze bridge declareert',
      nicMac: 'MAC (automatisch indien leeg)',
      noDisksHint: 'Geen schijf: de VM krijgt alleen de cd-/dvd-stations die je toevoegt.',
      noCdromsHint: 'Geen cd-/dvd-station: voeg er een toe om vanaf een ISO-image op te starten.',
      mountGuestTools: 'TVirt Guest Tools plaatsen bij de eerste start',
      mountGuestToolsHint: 'Zet de ISO met de virtio-drivers en de guest agent in een leeg cd-station (dat zo nodig wordt toegevoegd) — het installatieprogramma van Windows heeft die nodig om de schijven te zien.',
      noNicsHint: 'Geen netwerkinterface: de VM start zonder connectiviteit.',
      taggedMappings: 'Tagged VLAN-mappings',
      summaryDevices: 'Apparaten',
      bootOrderTitle: 'Opstartvolgorde',
      bootOrderHint: "Sleep om te herordenen — het eerste opstartbare apparaat wint; de NIC's starten PXE",
      bootOrderUp: 'Omhoog verplaatsen',
      bootOrderDown: 'Omlaag verplaatsen',
      createError: 'Aanmaken mislukt'
    },
    edit: {
      button: 'Bewerken',
      title: 'Virtuele machine bewerken',
      cancel: 'Annuleren',
      save: 'Opslaan',
      error: 'Wijzigen mislukt',
      modelStoppedOnly: 'Alleen te wijzigen als de VM uit staat',
      firmwareStoppedOnly: 'Firmware alleen te wijzigen als de VM uit staat — bij de volgende start start de machine op de nieuwe firmware en de UEFI-variabelen blijven',
      hugePagesStoppedOnly: 'Alleen te wijzigen als de VM uit staat — bij de volgende start ontstaat het geheugen op de nieuwe onderlaag',
      runningHint: 'De wijzigingen gelden bij de volgende power cycle',
      sectionCpu: 'CPU',
      sectionMemory: 'Geheugen',
      sectionPolicy: 'Beleid'
    },
    devices: {
      networkChip: 'fabric-netwerk',
      title: 'Apparaten',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'USB-apparaat toevoegen',
      addUsbTitle: 'Een klasse USB-apparaten aanvragen',
      usbClassHint:
        'De VM vraagt om een KLASSE USB-apparaten (een waarde van een tag usb-device), nooit om een specifiek apparaat: bij het starten wordt het concrete vrije apparaat op de node gekozen en gereserveerd. Tag de geregistreerde apparaten in Cluster › USB- en PCIe-resources.',
      usbTag: 'Tag (usb-device)',
      usbValue: 'Waarde van de klasse',
      noUsbTags: 'Geen enkele tag usb-device — maak er een aan en tag de geregistreerde apparaten in Cluster › USB- en PCIe-resources.',
      noUsbValues: 'Deze tag heeft nog geen gedeclareerde waarden.',
      usbEmpty: 'Geen USB-eis — voeg een klasse toe om bij het starten een apparaat door te geven.',
      usbClassChip: 'klasse',
      usbPortChip: 'poort',
      usbUnclaimed: 'Geen apparaat gereserveerd — dat lost zich op bij het starten van de VM.',
      addGpu: 'GPU toevoegen',
      addGpuTitle: 'Een klasse GPU aanvragen',
      gpuClassHint:
        "De VM vraagt om een KLASSE GPU (een waarde van een tag gpu-device), nooit om een specifieke kaart: bij het starten wordt de concrete vrije kaart op de node gekozen en gereserveerd, en gaat zijn HELE IOMMU-groep MEE. Tag de geregistreerde GPU's in Cluster › USB- en PCIe-resources.",
      gpuTag: 'Tag (gpu-device)',
      gpuValue: 'Waarde van de klasse',
      noGpuTags: "Geen enkele tag gpu-device — maak er een aan en tag de geregistreerde GPU's in Cluster › USB- en PCIe-resources.",
      noGpuValues: 'Deze tag heeft nog geen gedeclareerde waarden.',
      gpuEmpty: 'Geen GPU-eis — voeg een klasse toe om bij het starten een kaart door te geven.',
      gpuClassChip: 'klasse',
      gpuGroupChip: 'IOMMU-groep ×',
      gpuUnclaimed: 'Geen kaart gereserveerd — dat lost zich op bij het starten van de VM.',
      gpuPowerCycle: 'Geen GPU-hotplug — de wijzigingen gelden vanaf de volgende power cycle (PendingRestart)',
      actions: 'Acties',
      attachDisk: 'Schijf toevoegen',
      attachDiskTitle: 'Een schijf toevoegen',
      attach: 'Koppelen',
      noFreeDisks: 'Geen enkele ongebruikte schijf — maak er een aan in Virtuele machines › Ongebruikte schijven.',
      addCdrom: 'Station toevoegen',
      addCdromTitle: 'Een cd-/dvd-station toevoegen',
      editCdromTitle: 'Cd-/dvd-image wisselen',
      changeMedia: 'Cd-/dvd-image wisselen',
      ejectMedium: 'Uitwerpen',
      mountGuestTools: 'TVirt Guest Tools plaatsen',
      guestToolsMounted: 'TVirt Guest Tools geplaatst',
      guestToolsClickMount: 'Zet de ISO TVirt Guest Tools in het eerste lege cd-/dvd-station',
      guestToolsClickUnmount: 'Klik om uit te werpen — het station blijft, leeg',
      guestToolsNoSlot: 'Geen leeg cd-/dvd-station — voeg een station toe (of werp een medium uit) om de TVirt Guest Tools te plaatsen',
      guestToolsSkew: 'Gekoppeld v{pinned}; node {node} levert nu v{current}: uitwerpen en opnieuw koppelen om bij te werken',
      ejectGuestTools: 'TVirt Guest Tools uitwerpen (het station blijft, leeg)',
      guestToolsEjectConfirmTitle: 'De TVirt Guest Tools uitwerpen?',
      guestToolsEjectConfirmBody: 'Het medium wordt uit de draaiende VM geworpen — het cd-/dvd-station blijft, leeg.',
      applyLive: 'Meteen toepassen (de VM staat aan)',
      addNic: 'Interface toevoegen',
      addNicTitle: 'Een netwerkinterface toevoegen',
      editNicTitle: 'Netwerkinterface bewerken',
      bridgeChip: 'bridge',
      cable: 'Virtuele kabel',
      plug: 'De virtuele kabel aansluiten',
      unplug: 'De virtuele kabel loskoppelen',
      remove: 'Weghalen',
      removeTitle: '{device} weghalen?',
      removeBody: 'Bij een draaiende VM geldt de wijziging pas bij de volgende power cycle. Schijven en images worden losgekoppeld, nooit verwijderd.'
    }
  }
}
